import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { DateFieldCalendar } from '@gem/components';
import { popupsTasks } from '@gem/popups';
import dateService from '@gem/services/date-service';
import { noop } from '@gem/utils';

import { getLanguage } from 'UTILS/getLanguage';

import styles from './DateField.styles.m.css';

interface IDateFieldPresenter {
  value: Date | null;
  inputValue: string;
  onFocus(): void;
  onChangeInput(): void;
  setValue(value: Date): void;
}

interface IDateFieldPresenterProps {
  onChange(date: Date): void;
  minDate?: Date;
  value: Date;
}

export const useDateFieldPresenter = ({
  onChange,
  minDate,
  value,
}: IDateFieldPresenterProps): IDateFieldPresenter => {
  const presenter = useLocalObservable<IDateFieldPresenter>(() => ({
    value: null,
    onChangeInput: noop,

    setValue(value: Date): void {
      presenter.value = value;
    },

    onFocus(): void {
      if (!presenter.value) {
        return;
      }

      popupsTasks.openPopup(DateFieldCalendar, {
        params: {
          value: presenter.value,
          onChoose: onChange,
          calendarClassName: styles.calendar,
          popupClassName: styles.popup,
          minDate: minDate || new Date(new Date().getFullYear() - 1, 0, 1, 0, 0, 0, 0),
          locale: getLanguage(),
        },
      });
    },

    get inputValue(): string {
      const conf = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      };

      return dateService.format(presenter.value, conf) || '';
    },
  }));

  useEffect(() => {
    presenter.setValue(value);
  }, [value]);

  return presenter;
};
